const browserCheck = {
  isIE11: () => {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }
}

export default browserCheck;
